import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { UserService } from '../services/user.service';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

export const adminGuard: CanActivateFn = (route, state) => {
	const userService = inject(UserService);
	const router = inject(Router);

	const token = localStorage.getItem('authToken');

	if (!token) {
		router.navigate(['/login']);
		return false;
	}

	// If user details are already loaded, check role
	if (userService.userDetails()) {
		if (userService.isAdmin()) {
			return true;
		} else {
			router.navigate(['/']);
			return false;
		}
	}

	// Otherwise, fetch user info first
	return userService.getUserInfo$().pipe(
		map((response) => {
			if (userService.userDetails() && userService.isAdmin()) {
				return true;
			} else {
				router.navigate(['/']);
				return false;
			}
		}),
		catchError((error) => {
			router.navigate(['/login']);
			return of(false);
		})
	);
};
